import { render, staticRenderFns } from "./WxDetail.vue?vue&type=template&id=454910d3&scoped=true&"
import script from "./WxDetail.vue?vue&type=script&lang=js&"
export * from "./WxDetail.vue?vue&type=script&lang=js&"
import style0 from "./WxDetail.vue?vue&type=style&index=0&id=454910d3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454910d3",
  null
  
)

export default component.exports